import { AxiosResponse } from 'axios';
import { InviteeListResponse } from 'types/entity/invitee-list-response';
import { InviteeModel } from 'types/entity/invitee-model';
import { http } from './settings';

export const fetchProjectInvitees = (selectedProjectId: string): Promise<InviteeModel[] | undefined> => http.get(`/projects/${selectedProjectId}/invitees`)
  .then((value: AxiosResponse<InviteeListResponse>) => value.data.invitees || []);
